var exports = {
  "kL": "x52a3aa3b--b7c582--container",
  "uq": "x52a3aa3b--b7c582--rubric-item",
  "M_": "x52a3aa3b--b7c582--special-promo-item",
  "Ot": "x52a3aa3b--b7c582--special-promo-item-logo",
  "ou": "x52a3aa3b--b7c582--tooltip-container",
};

module.exports = exports;
